/**
 * @flow
 * @relayHash 7aa2ba3ec9adf8e7a63d834e3b8d75e0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getOrgQueryVariables = {|
  appName?: ?string
|};
export type getOrgQueryResponse = {|
  +authorizedOrgs: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +userRole: ?string,
    +suborgs: $ReadOnlyArray<{|
      +id: string,
      +name: string,
      +region: ?string,
      +timezone: ?string,
      +timezoneOffset: ?string,
      +timezoneAbbr: ?string,
      +propertyLogoUrl: ?string,
      +propertyManagerLogoUrl: ?string,
    |}>,
  |}>
|};
export type getOrgQuery = {|
  variables: getOrgQueryVariables,
  response: getOrgQueryResponse,
|};
*/


/*
query getOrgQuery(
  $appName: String
) {
  authorizedOrgs(appName: $appName) {
    id
    name
    userRole
    suborgs {
      id
      name
      region
      timezone
      timezoneOffset
      timezoneAbbr
      propertyLogoUrl
      propertyManagerLogoUrl
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "appName",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "authorizedOrgs",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appName",
        "variableName": "appName"
      }
    ],
    "concreteType": "Org",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "userRole",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suborgs",
        "storageKey": null,
        "args": null,
        "concreteType": "Suborg",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "region",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "timezone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "timezoneOffset",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "timezoneAbbr",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyLogoUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyManagerLogoUrl",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getOrgQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getOrgQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getOrgQuery",
    "id": null,
    "text": "query getOrgQuery(\n  $appName: String\n) {\n  authorizedOrgs(appName: $appName) {\n    id\n    name\n    userRole\n    suborgs {\n      id\n      name\n      region\n      timezone\n      timezoneOffset\n      timezoneAbbr\n      propertyLogoUrl\n      propertyManagerLogoUrl\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f9f0aca822bc20d1933c6e16df32502d';
module.exports = node;
